import { jsxs as _jsxs } from "react/jsx-runtime";
import { jsx as _jsx } from "react/jsx-runtime";

let _ = t => t,
    _t;

import UIFlex from 'UIComponents/layout/UIFlex';
import UIBadge from 'UIComponents/badge/UIBadge';
import styled from 'styled-components';
import FormattedMessage from 'I18n/components/FormattedMessage';
import breakpoint from 'pricing-pages-ui/constants/Breakpoints';
import UIImage from 'UIComponents/image/UIImage';
import { ProductLinePageIcons } from 'ui-addon-upgrades/_core/productPage/ProductPageIcons';
import { CompactTitle, FlushedTitle } from '../SharedComponents';
const StyledFlex = styled(UIFlex).withConfig({
  displayName: "PlanPickerHeader__StyledFlex",
  componentId: "sc-1md3azx-0"
})(["", ""], breakpoint.phone(_t || (_t = _`
    flex-direction: column;
    align-items: start;
  `)));

const PlanPickerHeader = ({
  productLine,
  compact,
  isNew = false,
  // trackingSource,
  id
}) => {
  const titleKey = compact ? `planBuilder.plansHeader.${productLine}.compactTitle` : `planBuilder.plansHeader.${productLine}.largeTitle`;
  return compact ? /*#__PURE__*/_jsx(CompactTitle, {
    className: "m-bottom-8",
    "aria-level": 3,
    id: id,
    children: /*#__PURE__*/_jsx(FormattedMessage, {
      message: titleKey
    })
  }) : /*#__PURE__*/_jsxs(StyledFlex, {
    align: "end",
    className: "m-bottom-3",
    id: id,
    children: [/*#__PURE__*/_jsxs("div", {
      className: "align-center",
      children: [ProductLinePageIcons[productLine] && /*#__PURE__*/_jsx(UIImage, {
        className: "display-inline m-bottom-1 m-right-2",
        src: ProductLinePageIcons[productLine],
        width: 24
      }), /*#__PURE__*/_jsx(FlushedTitle, {
        "aria-level": 3,
        children: /*#__PURE__*/_jsx(FormattedMessage, {
          message: titleKey
        })
      }), isNew && /*#__PURE__*/_jsx(UIBadge, {
        use: "new",
        className: "m-left-3",
        children: /*#__PURE__*/_jsx(FormattedMessage, {
          message: "pricingPage.new"
        })
      })]
    }), /*#__PURE__*/_jsx("div", {
      className: "m-left-auto"
    })]
  });
};

export default PlanPickerHeader;